export const NOTIFICATION_ALERT_STYLES = {
  success: {
    bgcolor: "#F0FDF4",
    borderColor: "#B9F8CF",
    iconColor: "#00C950",
  },
  error: {
    bgcolor: "#FEF2F2",
    borderColor: "#FFC9C9",
    iconColor: "#FB2C36",
  },
  warning: {
    bgcolor: "#FFF7ED",
    borderColor: "#FFD6A7",
    iconColor: "#FF6900",
  },
  /** Neutral gray. Use via getSeverity={() => "default"} (e.g. dosage notifications). */
  default: {
    bgcolor: "#F8FAFC",
    borderColor: "#E6E6E6",
    iconColor: "#718096",
  },
};

/**
 * Style-map key for Alert row colors.
 * Missing / unknown keys use warning (orange), not gray — pass "default" explicitly for gray.
 */
export function resolveNotificationStyleKey(severity) {
  if (severity && NOTIFICATION_ALERT_STYLES[severity]) {
    return severity;
  }
  return "warning";
}

export function getNotificationAlertStyles(severity) {
  return NOTIFICATION_ALERT_STYLES[resolveNotificationStyleKey(severity)];
}

/**
 * MUI Alert only accepts success | error | warning | info.
 * Our "default" style key maps to info so icons/a11y stay neutral.
 */
export function toMuiAlertSeverity(styleKey) {
  if (styleKey === "success" || styleKey === "error" || styleKey === "warning") {
    return styleKey;
  }
  return "info";
}
